<div class="row">
<div class="col-md-12">
    <h2>Helpline Details</h2>
    </div>
</div>
<app-home-card-config [contenttype]="'helpline'">></app-home-card-config>
